__turbopack_context__.v({
  "SProviderLink": "axhQjG_SProviderLink",
});
